import { useMemo } from "react";
import { ArticleIndexView } from "../components/ArticleIndexView";
import { Seo } from "../components/Seo";
import { useLocale } from "../i18n";
import { buildArticleIndexHead } from "../seo";

export function ArticleIndexPage() {
  const locale = useLocale();
  const head = useMemo(() => buildArticleIndexHead(locale), [locale]);

  return (
    <>
      <Seo head={head} />
      <ArticleIndexView />
    </>
  );
}
